import { combineReducers, createStore } from "redux";
import { domainAccessModalReducer } from "./domain-access-modal/reducers";
import { globalConfigReducer } from "./global-config/reducers";
import { managementLayoutReducer } from "./management-layout/reducers";
import { onboardingTooltipReducer } from "./onboarding-tooltip/reducers";
import { settingsPanelReducer } from "./settings-panel/reducers";
import { unsavedChangesModalReducer } from "./unsaved-changes-modal/reducers";

const rootReducer = combineReducers({
  settingsPanel: settingsPanelReducer,
  domainAccessModal: domainAccessModalReducer,
  unsavedChangesModal: unsavedChangesModalReducer,
  globalConfig: globalConfigReducer,
  onboardingTooltip: onboardingTooltipReducer,
  managementLayout: managementLayoutReducer
});

export type AppState = ReturnType<typeof rootReducer>;

export const globalStore = createStore<any, any, any, any>(rootReducer);
const configureStore = () => globalStore;
export default configureStore;
